import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import NotificationProvider from "components/NotificationProvider";
import { selectIsClient } from "features/user/userSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import VehicleStatusView from "../VehicleStatus/VehicleStatusView";
import CustomInput from "components/CustomInput";
import { useGetLotsQuery } from 'features/lots/lotSlice';
import { useBulkUpdateMutation } from "features/vehicles/vehicleSlice";

export const BulkEditAssetPopupDialog = ({
    selectedRows,
    reloadAssets,
    open,
    setOpen
}) => {

    let [bulkUpdate, { isLoading: isSaving }] = useBulkUpdateMutation();
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    lots = lots || [];

    const [status, setStatus] = useState("");
    const [lotId, setLotId] = useState(null);


    const onSave = async () => {
        setOpen(false);
        const result = await bulkUpdate(
        {
            lotId: lotId,
            statusId: status,
            vehicleIds: selectedRows 
        });

        if (result && !result.error) {
            NotificationProvider.success("Successfully updated assets status");
            reloadAssets && reloadAssets();
        } else {
            NotificationProvider.error("Failed updateing assets status");
        }
    }

    const onClose = () => {
        setOpen(false);
    }


    const onStatusChangeOption = (value) => {
       setStatus(value);
    }

    
    const onLotChangeOption = (value) => {
       setLotId(value);
    }

    return (

        <Authorize profile={permissionProfiles.ASSETS.ASSETS_PAGE_BULK_EDIT_STATUS}>
            <Dialog onClose={onClose} open={open} maxWidth='md' fullWidth>
                <DialogTitle>
                    Update Asset Status
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction='column'>
                        <Grid item>
                            <VehicleStatusView
                                clientId={null}
                                label={"Assets new status"}
                                value={status}
                                onChange={val => onStatusChangeOption( +val)}
                                readonly={false}
                                excludeCheckInOutStatuses={true}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <CustomInput
                                id="loId"
                                label="Assets new lot (not required)"
                                value={lotId}
                                elementType="dropdown"
                                onChange={val => onLotChangeOption(+val)}
                                values={lots}
                                showEmpty
                                touched
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" variant="outlined" >Cancel</Button>
                    <Tooltip title={'This will update the status of the selected assets'}>
                        <span>
                            <Button onClick={onSave}
                                color="primary" variant="contained"
                                disabled={!status}>Bulk Update ({selectedRows?.length}) {selectedRows?.length > 1 ? 'Assets' : 'Asset'} </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </Authorize>
    )
}